export const PERMISSIONS = {
  access_credit_limit_module: "access_credit_limit_module",
  access_it_module: "access_it_module",
  access_lead_module: "access_lead_module",
  access_marketplace_module: "access_marketplace_module",
  access_supplier_factoring_module: "access_supplier_factoring_module",
  access_supplier_reverse_factoring_module:
    "access_supplier_reverse_factoring_module",
  add_contact_group: "add_contact_group",
  add_department_contact: "add_department_contact",
  add_group_permission: "add_group_permission",
  add_groups: "add_groups",
  add_permissions: "add_permissions",
  add_user: "add_user",
  allocation_approval: "allocation_approval",
  allocation_submit: "allocation_submit",
  approval_level_ceo: "approval_level_ceo",
  approval_level_head_compliance: "approval_level_head_compliance",
  approval_level_head_funding: "approval_level_head_funding",
  approval_level_head_icpl: "approval_level_head_icpl",
  approval_level_head_legal: "approval_level_head_legal",
  approval_level_head_risk: "approval_level_head_risk",
  approve_credit_limit: "approve_credit_limit",
  book_meeting_risk_manager: "book_meeting_risk_manager",
  book_meeting_rm_manager: "book_meeting_rm_manager",
  book_meeting_support_manager: "book_meeting_support_manager",
  create_lead: "create_lead",
  dashboard_admin: "dashboard_admin",
  delete_user: "delete_user",
  doc_reviewed_by_operation: "doc_reviewed_by_operation",
  doc_reviewed_by_risk: "doc_reviewed_by_risk",
  edit_primary_contact: "edit_primary_contact",
  edit_user: "edit_user",
  finance_edit: "finance_edit",
  finance_on_salesforce: "finanance-on-salesforce",
  invoice_financing: "invoice_financing",
  invoice_financing_transaction: "invoice_financing_transaction",
  show_ewallets: "show_ewallets",
  get_account: "get_account",
  get_all_accounts: "get_all_accounts",
  get_all_credit_limits: "get_all_credit_limits",
  get_all_departments: "get_all_departments",
  get_all_groups: "get_all_groups",
  get_all_leads: "get_all_leads",
  get_all_permissions: "get_all_permissions",
  get_all_users: "get_all_users",
  get_assigned_credit_limits: "get_assigned_credit_limits:",
  get_credit_limit: "get_credit_limit",
  get_insurer: "get_insurer",
  get_platform_usage: "get_platform_usage",
  invoice_edit: "invoice_edit",
  legal_country_update: "legal_country_update",
  manage_credit_limit_requests: "manage_credit_limit_requests",
  manage_internal_teams: "manage_internal_teams",
  manage_org_chart: "manage_org_chart",
  map_access_compliance: "map_access_compliance",
  map_access_legal: "map_access_legal",
  map_access_operation: "map_access_operation",
  map_access_risk: "map_access_risk",
  map_admin: "map_admin",
  update_map_owner: "update_map_owner",
  map_approval: "map_approval",
  map_category_update: "map_category_update",
  risk_cc_decision: "risk_cc_decision",
  ipl_cc_decision: "ipl_cc_decision",
  ipcl_cc_decision: "ipcl_cc_decision",
  icpl_cc_decision: "icpl_cc_decision",
  map_cc_review: "map_cc_review",
  map_compliance_decision: "map_compliance_decision",
  map_compliance_review: "map_compliance_review",
  map_edit_compliance: "map_edit_compliance",
  map_edit_legal: "map_edit_legal",
  map_edit_operation: "map_edit_operation",
  map_edit_risk: "map_edit_risk",
  map_legal_decision: "map_legal_decision",
  map_legal_review: "map_legal_review",
  map_operation_decision: "map_operation_decision",
  map_operation_review: "map_operation_review",
  map_risk_decision: "map_risk_decision",
  map_risk_review: "map_risk_review",
  map_view_compliance: "map_view_compliance",
  map_view_legal: "map_view_legal",
  map_view_risk: "map_view_risk",
  override_risk_score: "override_risk_score",
  reject_credit_limit: "reject_credit_limit",
  request_credit_limit: "request_credit_limit",
  restricted_view_stats: "restricted_view_stats",
  restricted_map_details: "restricted_map_details",
  rm_risk_call: "rm_risk_call",
  show_accounts: "show_accounts",
  show_all_accounts: "show_all_accounts",
  show_all_dashboard: "show_all_dashboard",
  show_all_funders: "show_all_funders",
  show_funder_management: "show_funder_management",
  show_all_invoices: "show_all_invoices",
  show_all_reports: "show_all_reports",
  show_balances: "show_balances",
  show_billings: "show_billings",
  show_campaign_testing: "show_campaign_testing",
  show_cargo_tracking: "show_cargo_tracking",
  show_cl_report: "show_cl_report",
  show_company_profile: "show_company_profile",
  show_configuration: "show_configuration",
  show_countries: "show_countries",
  show_credit_limits: "show_credit_limits",
  show_dashboard: "show_dashboard",
  show_emails: "show_emails",
  show_ewallet: "show_ewallet",
  show_guides: "show_guides",
  show_insurer_stats: "show_insurer_stats",
  show_invoice_statuses: "show_invoice_statuses",
  show_leads: "show_leads",
  show_leaves: "show_leaves",
  show_maps: "show_maps",
  show_my_reports: "show_my_reports",
  show_onboarding_statuses: "show_onboarding_statuses",
  show_onboardings: "show_onboardings",
  show_organization_chart: "show_organization_chart",
  show_platform_usage: "show_platform_usage",
  show_request_financing: "show_request_financing",
  show_risk_management: "show_risk_management",
  show_scripts: "show_scripts",
  show_statuses: "show_statuses",
  show_support_tickets: "show_support_tickets",
  show_tax_invoices: "show_tax_invoices",
  show_termsheets: "show_termsheets",
  show_withdrawl_deposit: "show_withdrawl_deposit",
  show_user_management: "show_user_management",
  termsheet_approver: "termsheet_approver",
  termsheet_editor: "termsheet_editor",
  termsheet_financing: "termsheet_financing",
  withdrawl_deposit_approver: "withdrawl_deposit_approver",
  withdrawl_deposit_editor: "withdrawl_deposit_editor",
  test_customer_io: "test_customer_io",
  update_contact_account_permissions: "update_contact_account_permissions",
  update_contact_group: "update_contact_group",
  update_credit_limit: "update_credit_limit",
  update_department_contact: "update_department_contact",
  update_group_permission: "update_group_permission",
  update_trasaction: "update_trasaction",
  invoice_reviewed: "invoice_reviewed",
  first_invoice_approve: "first_invoice_approve",
  finance_invoice_approve: "finance_invoice_approve"
};

export function isComplianceViewOnly(userPermissions: string[]): boolean {
  const hasShowMaps = userPermissions.includes(PERMISSIONS.show_maps);
  const hasEdit =
    userPermissions.includes(PERMISSIONS.map_access_compliance) ||
    userPermissions.includes(PERMISSIONS.map_edit_compliance) ||
    userPermissions.includes(PERMISSIONS.map_compliance_review) ||
    userPermissions.includes(PERMISSIONS.map_compliance_decision);
  return hasShowMaps && !hasEdit;
}
